
















































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class EmissionReportHelp extends Vue {
  tab = null;
}
